module.exports = __webpack_public_path__ + "static/media/caros-bold-italic.96160d0c.woff2";